import {
  setActiveDataGoogleSheets,
  setDataGoogleSheets,
} from "../../../../store/slices/googleSheetsSlice";
import { removeUser } from "../../../../store/slices/userSlice";
import { errorToast } from "../../../methods/toast";
import { $hostTest } from "../../http";

const userId = localStorage.getItem("@storage_User_Id");

export const initGoogleSheet = (formData, setLoading, setIsConnected) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $hostTest.post(
        `/integrations/google/initialization`,
        formData
      );

      if (data.code === 200) {
        setIsConnected(true);
        dispatch(getGoogleSheetData(userId));
      } else {
        errorToast("Ошибка инициализации GoogleSheets");
      }
    } catch (error) {
      if (!error.response) {
        errorToast("Ошибка сети. Проверьте подключение.");
      } else if (error.response.status === 401) {
        dispatch(removeUser());
      } else if (error.response.status === 500) {
        errorToast("Ошибка сервера. Попробуйте позже.");
      } else if (error.response.data?.message === "error: invalid api url") {
        errorToast("Неверный API URL, повторите попытку.");
      } else if (
        error.response.data?.message?.includes("TLS handshake timeout")
      ) {
        errorToast(
          "Произошла ошибка соединения с Bitrix. Повторите попытку позже."
        );
      }

      console.error("initBitrix error:", error);
    } finally {
      setLoading(false);
    }
  };
};

export const getGoogleSheetData = (userId) => {
  return async (dispatch) => {
    try {
      const { data } = await $hostTest.get(
        `/integrations/google/getintegration?userId=${userId}`
      );
      if (data.code === 200) {
        if (data.integrations) {
          dispatch(setDataGoogleSheets(data.integrations));
          localStorage.setItem(
            "dataGoogleSheets",
            JSON.stringify(data.integrations)
          );
        } 
      } else {
        errorToast("Ошибка получения данных GoogleSheets");
      }
    } catch (error) {
      if (!error.response) {
        errorToast("Ошибка сети. Проверьте подключение.");
      } else if (error.response.status === 401) {
        dispatch(removeUser());
      } else if (error.response.status === 500) {
        errorToast("Ошибка сервера. Попробуйте позже.");
      } else if (error.response.data?.message === "error: invalid api url") {
        errorToast("Неверный API URL, повторите попытку.");
      } else if (
        error.response.data?.message?.includes("TLS handshake timeout")
      ) {
        errorToast(
          "Произошла ошибка соединения с Bitrix. Повторите попытку позже."
        );
      }

      console.error("initBitrix error:", error);
    }
  };
};

export const deactivationGoogleSheets = (dataReq, setLoading, navigate) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $hostTest.post(
        `/integrations/google/deactivation`,
        dataReq
      );
      if (data.code === 200) {
        setLoading(false);
        localStorage.removeItem("dataGoogleSheets");
        dispatch(setActiveDataGoogleSheets(null));
        localStorage.removeItem("activeDataGoogleSheets");
        dispatch(getGoogleSheetData(userId));
        navigate("/integration");
      } else {
        setLoading(false);
        errorToast("Ошибка деактивации GoogleSheets");
      }
    } catch (error) {
      setLoading(false);
      if (!error.response) {
        errorToast("Ошибка сети. Проверьте подключение.");
      } else if (error.response.status === 401) {
        dispatch(removeUser());
      } else if (error.response.status === 500) {
        errorToast("Ошибка сервера. Попробуйте позже.");
      }

      console.error("deactivationGoogleSheets error:", error);
    }
  };
};
